import { render, staticRenderFns } from "./carrierLogpoint.vue?vue&type=template&id=4af7d382&scoped=true&"
import script from "./carrierLogpoint.vue?vue&type=script&lang=js&"
export * from "./carrierLogpoint.vue?vue&type=script&lang=js&"
import style0 from "./carrierLogpoint.vue?vue&type=style&index=0&id=4af7d382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af7d382",
  null
  
)

export default component.exports